import useHasPermissions from "src/hooks/useHasPermissions";

const PermissionWrapper = ({ children, permission }) => {
	const hasPermission = useHasPermissions(permission);

	if (!hasPermission) return null;

	return children;
};

export default PermissionWrapper;
